import type { ReactNode } from 'react';

interface PopoverProps {
  children: ReactNode;
}

export function Sidebar({ children }: PopoverProps) {
  return (
    <div className="group flex h-full w-auto flex-col gap-sm bg-default text-default">
      {children}
    </div>
  );
}

Sidebar.displayName = 'Sidebar';
